import { schema } from 'normalizr';

const orderTagSchema = new schema.Entity('orderTags');

export default orderTagSchema;
